
import Scroller from 'vux/src/components/scroller/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Panel from 'vux/src/components/panel/index.vue'

import { getPatientInfo, getClinicDiagList } from '@/api/index.js'
export default {
components: {Scroller, Loading, Panel},
data () {
return {
baseInfo: {},
visitedLog: [],
visitTotal: '',
showSpin: false,
onFetching: false,
pageNum: '1',
baseInfoParams: {},
visitedLogParams: {},
type: '1',
PageIndex: 1, // 页码从第一页开始
PageSize: 5, // 煤业显示的条数
isShow: false, // 是否显示scroller,第一次请求数据过程中隐藏插件，不隐藏的时候会显示“请上拉刷新数据”的字样，不好看
showloading: false,
textloading: '加载中',
showUp: true,
isbounce: false,
lists: [],
upobj: {
content: '上拉加载数据',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '上拉加载数据',
upContent: '上拉加载数据',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
},
isShowLoading: false,
textLoading: '加载中',
scrollerStatus: {
pullupStatus: 'default'
}
}
},
created () {

this.getDetails(true)
this.loadData()
this.$nextTick(() => {
this.$refs.scroller.reset()
})
},
methods: {
async loadData () {
this.showSpin = true
const emrId = this.$route.query.emrId
const appDate = this.$route.query.appDate
this.baseInfoParams = {
emrId,
appDate: { appDate }
}
const baseInfo = await getPatientInfo(this.baseInfoParams)
if (baseInfo) {
this.showSpin = false
this.baseInfo = baseInfo[0]
}
},

async getDetails (isEmpty) {
this.showloading = true
const emrId = this.$route.query.emrId

const idNo = this.$route.query.idNo
this.visitedLogParams = {
emrId,
params: {
idNo,
pageNum: this.pageNum++,
pageSize: '20'
}
}
const visitedLog = await getClinicDiagList(this.visitedLogParams)
if (visitedLog && isEmpty) {
this.visitedLog = visitedLog[0].result
this.visitTotal = visitedLog[0].total
} else if (visitedLog && !isEmpty && this.visitedLog.length < this.visitTotal) {
this.visitedLog = this.visitedLog.concat(visitedLog[0].result)
this.visitTotal = visitedLog[0].total
}

if (isEmpty) {
this.lists = []
this.show = false
} else {

if (visitedLog && visitedLog[0].result.length === 0) {
setTimeout(() => {
this.showloading = false
}, 500)

this.$refs.scroller.disablePullup()
this.showToast = true
this.isShowLoading = false
this.scrollerStatus.pullupStatus = 'disabled' 
return
}
}

this.isShow = true
this.showloading = false
if (!isEmpty) {
this.scrollerStatus.pullupStatus = 'default'
this.$nextTick(() => {
this.$refs.scroller.reset()
})
}
},
selPullUp () {
this.getDetails(false)
},
back () {
this.$router.go(-1)
}
},
activated () {
this.$refs.scroller.reset()
}
}



// WEBPACK FOOTER //
// ./src/views/AppointDetail.vue